var p1 = "/static/a9dfdc870645fd57.png";

export { p1 as default };
//# sourceMappingURL=p_1.png.js.map
